module.exports = __webpack_public_path__ + "img/img_mexicali_tag.d56096c5.svg";